var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED823E83-4EAD-4754-BCDD-5ECC2A3904F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-page-Full",
    transform: "translate(-90, -887)",
    stroke: "#256BFD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audience",
    transform: "translate(24, 494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Secret-Fans-Copy-4",
    transform: "translate(0, 361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons_24/Inactive",
    transform: "translate(66, 32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5866475,2.09232 C8.9931475,2.03223 9.4123475,2 9.8441475,2 C14.9491475,2 18.2990475,6.50484 19.4244475,8.2868 C19.5606475,8.5025 19.6287475,8.6103 19.6668475,8.7767 C19.6955475,8.9016 19.6954475,9.0987 19.6668475,9.2236 C19.6286475,9.3899 19.5601475,9.4985 19.4229475,9.7156 C19.1230475,10.1901 18.6659475,10.8571 18.0602475,11.5805 M4.5680675,3.71504 C2.4059975,5.1817 0.938197503,7.2194 0.264857503,8.2853 C0.128027503,8.5019 0.0596175026,8.6102 0.0214875026,8.7765 C-0.00715249738,8.9014 -0.00716249738,9.0984 0.0214575026,9.2234 C0.0595775026,9.3897 0.127677503,9.4975 0.263877503,9.7132 C1.3892875,11.4952 4.7391575,16 9.8441475,16 C11.9025475,16 13.6756475,15.2676 15.1325475,14.2766 M0.844167503,0 L18.8441475,18 M7.7228475,6.87868 C7.1799475,7.4216 6.8441675,8.1716 6.8441675,9 C6.8441675,10.6569 8.1873475,12 9.8441475,12 C10.6725475,12 11.4225475,11.6642 11.9654475,11.1213",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.5906f9b1dd8b1661d97dee0d6468922f.svg";
export { ForwardRef as ReactComponent };